import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-search",
  "use": "icon-search-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-search\">\r\n  <path id=\"icon-search_search\" d=\"M29.175,25.189l-6.6-6.6a12.18,12.18,0,1,0-10.364,5.828,12.1,12.1,0,0,0,6.378-1.842l6.6,6.6a2.817,2.817,0,1,0,3.984-3.985Zm-16.966-4.53a8.451,8.451,0,1,1,8.452-8.451A8.452,8.452,0,0,1,12.208,20.659Z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol